import { createAction } from 'redux-actions';
import { generateAutoExchange } from 'src/utils/submission/submission-utility';
import { callApi, getEndpoint } from 'src/utils/api';
import { analyticsDataLayer } from '../../utils/analytics-helper';
import { AutoExchangePayloadPreSubmit } from './types';
import { ExecuteAutoExchange } from './actionTypes';

const DEFAULT_STATE = {
  confirmationNumber: '',
  error: null,
  hasFailed: false,
  isLoaded: false,
  isLoading: false,
  paperlessUpdate: null,
  transactions: [],
  tradeDate: '',
};

export default function executeAutoExchange(
  state = DEFAULT_STATE,
  { payload, type }
) {
  switch (type) {
    case `${ExecuteAutoExchange.EXECUTE_RECURRING_EXCHANGE}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
        transactions: [],
      };
    case `${ExecuteAutoExchange.EXECUTE_RECURRING_EXCHANGE}_FULFILLED`: {
      const someFailed = payload.body.transactions.some(
        (transaction) => !transaction.success
      );

      const allFailed = payload.body.transactions.every(
        (transaction) => !transaction.success
      );

      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: false,
        validationFailed: someFailed || allFailed,
        transactions: payload.body.transactions,
        confirmationNumber: null,
        tradeDate: null,
        paperlessUpdate: payload.body.paperlessUpdate,
      };
    }
    case `${ExecuteAutoExchange.EXECUTE_RECURRING_EXCHANGE}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
        error: payload.body,
      };

    case `${ExecuteAutoExchange.EXECUTE_RECURRING_EXCHANGE}_RESET`: {
      return {
        ...DEFAULT_STATE,
      };
    }
    case ExecuteAutoExchange.UPDATE_ACKNOWLEDGEMENT:
      return {
        ...state,
        hasAcknowledgedIRAContributionLimit: payload,
      };

    default:
      return state;
  }
}

export const submitAutoExchange = ({
  paperless,
  priorPaperless,
  autoExchangeFromSummaryFund,
  autoExchangeToSummaryFund,
  exchangeFrequency,
  autoExchangeAmount,
  iraWithholding,
  disbursementType,
  electionAgreementUniqueId1,
  electionAgreementUniqueId2,
}: AutoExchangePayloadPreSubmit) => {
  const payload = generateAutoExchange(
    paperless,
    priorPaperless,
    autoExchangeFromSummaryFund,
    autoExchangeToSummaryFund,
    exchangeFrequency,
    autoExchangeAmount,
    iraWithholding,
    disbursementType,
    electionAgreementUniqueId1,
    electionAgreementUniqueId2
  );

  try {
    const getAnalyticsDataForTransaction = (payload) => {
      const { systematicTransactions } = payload;
      const purchaseAmounts = systematicTransactions.map((target) => {
        return target.amount;
      });

      return {
        amount: purchaseAmounts,
      };
    };
    analyticsDataLayer({
      accountTypes: [
        autoExchangeFromSummaryFund.productType,
        autoExchangeToSummaryFund.productType,
      ],
      ...getAnalyticsDataForTransaction(payload),
      quantity: 1, // only allow single recurring exchange
    });
  } catch (e) {
    // don't let analytics errors cause other things to fail
  }
  return (dispatch) => {
    const action = createAction(ExecuteAutoExchange.EXECUTE_RECURRING_EXCHANGE)(
      callApi(getEndpoint('autoExchange'), { method: 'POST' }, payload)
    );
    dispatch(action);
  };
};

export const resetAutoExchangeSubmit = () => {
  return createAction(
    `${ExecuteAutoExchange.EXECUTE_RECURRING_EXCHANGE}_RESET`
  )();
};
